export default __webpack_public_path__ + "static/media/Outside_summer_2_1920.94499037.png";